import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Selective preloading strategy for performance optimization
 * Preloads routes marked with preload: true in route data
 */
@Injectable({
  providedIn: 'root'
})
export class SelectivePreloadStrategy implements PreloadingStrategy {
  preload(route: Route, fn: () => Observable<any>): Observable<any> {
    // Preload if route data indicates it should be preloaded
    if (route.data && route.data['preload']) {
      console.log('Preloading route:', route.path);
      return fn();
    }
    
    // Don't preload by default
    return of(null);
  }
}